import React from 'react';
import { InputGroup, Form } from 'react-bootstrap';

const formatCurrency = (value) => {
    if (!value && value !== 0) return '';
    // Parse as number first to handle decimals correctly
    const numericValue = typeof value === 'string' ? parseFloat(value.replace(/[^\d.-]/g, '')) : parseFloat(value);
    if (isNaN(numericValue)) return '';
    // Round to remove decimals and format with thousand separators
    return Math.round(numericValue).toLocaleString('es-CO');
};

const parseCurrency = (formattedValue) => {
    if (!formattedValue) return '';
    // Remove all non-digits
    return formattedValue.replace(/\D/g, '');
};

const CurrencyInput = ({
    value,
    onChange,
    placeholder = '0',
    disabled = false,
    name,
    ...rest
}) => {
    const [displayValue, setDisplayValue] = React.useState('');

    React.useEffect(() => {
        setDisplayValue(formatCurrency(value));
    }, [value]);

    const handleChange = (e) => {
        const input = e.target.value;
        const numericValue = parseCurrency(input);

        // Update display with formatted value
        setDisplayValue(formatCurrency(numericValue));

        // Call parent onChange with raw numeric value
        if (onChange) {
            onChange(numericValue);
        }
    };

    return (
        <InputGroup>
            <InputGroup.Text>$</InputGroup.Text>
            <Form.Control
                type="text"
                value={displayValue}
                onChange={handleChange}
                placeholder={placeholder}
                disabled={disabled}
                name={name}
                {...rest}
            />
        </InputGroup>
    );
};

export default CurrencyInput;
